export default "__VITE_ASSET__b0d9cd3d__"